import type { ThemeOptions } from '@mui/material';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    code: React.CSSProperties;
    codeBlock: React.CSSProperties;
    metaLabel: React.CSSProperties;
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    code?: React.CSSProperties;
    codeBlock?: React.CSSProperties;
    metaLabel?: React.CSSProperties;
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    code: true;
    codeBlock: true;
    metaLabel: true;
  }
}

export const typography: ThemeOptions['typography'] = {
  fontFamily: "'Lato', sans-serif",
  fontWeightLight: 400,
  fontWeightRegular: 400,
  fontWeightMedium: 700,
  fontWeightBold: 700,
  body1: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  body2: {
    fontSize: '.875rem',
    fontWeight: 400,
    lineHeight: 1.43,
  },
  h1: {
    fontFamily: "'Encode Sans', sans-serif",
    fontSize: '2rem',
    fontWeight: 700,
    lineHeight: 'normal',
  },
  h2: {
    fontFamily: "'Encode Sans', sans-serif",
    fontSize: '1.5rem',
    fontWeight: 700,
    lineHeight: 'normal',
  },
  h3: {
    fontFamily: "'Encode Sans', sans-serif",
    fontSize: '1.25rem',
    fontWeight: 700,
    lineHeight: 'normal',
  },
  h4: {
    fontFamily: "'Encode Sans', sans-serif",
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: 'normal',
  },
  h5: {
    fontFamily: "'Encode Sans', sans-serif",
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 'normal',
  },
  h6: {
    fontFamily: "'Encode Sans', sans-serif",
    fontSize: '0.75rem',
    fontWeight: 500,
    lineHeight: 'normal',
  },
  subtitle1: {
    fontSize: '1rem',
    fontWeight: 700,
    lineHeight: 1.75,
  },
  subtitle2: {
    fontSize: '.875rem',
    fontWeight: 400,
    lineHeight: 1.57,
  },
  overline: {
    fontSize: '.75rem',
    fontWeight: 400,
    lineHeight: 2.66,
    textTransform: 'uppercase',
  },
  caption: {
    fontSize: '.75rem',
    fontWeight: 400,
    lineHeight: 1.66,
  },
  metaLabel: {
    fontSize: '.75rem',
    fontWeight: 400,
    lineHeight: 1,
  },
  code: {
    fontFamily: "'Courier Prime', monospace",
    fontSize: '.875rem',
    fontWeight: 400,
  },
  codeBlock: {
    fontFamily: "'Courier Prime', monospace",
    fontSize: '.875rem',
    fontWeight: 700,
  },
  button: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.71,
    textTransform: 'unset',
  },
};
